module.exports = __webpack_public_path__ + "media/img/vca/nomh3-afd9a8189c66953ad0f30c75c1fefa0c.png";